// Auto-generated

  import React from 'react'
import Loadable from 'Components/LoadableToImported'

const loading = () => ''


  export const BuildingInsurance = Loadable({
        loader: () => import(/* webpackChunkName: "BuildingInsurance" */ './BuildingInsurance'),
        loading,
        chunkName: 'BuildingInsurance',
      })

export const BuildingMaintenance = Loadable({
        loader: () => import(/* webpackChunkName: "BuildingMaintenance" */ './BuildingMaintenance'),
        loading,
        chunkName: 'BuildingMaintenance',
      })

export const BuildingManagement = Loadable({
        loader: () => import(/* webpackChunkName: "BuildingManagement" */ './BuildingManagement'),
        loading,
        chunkName: 'BuildingManagement',
      })

export const BuildingTaxes = Loadable({
        loader: () => import(/* webpackChunkName: "BuildingTaxes" */ './BuildingTaxes'),
        loading,
        chunkName: 'BuildingTaxes',
      })

export const CableTv = Loadable({
        loader: () => import(/* webpackChunkName: "CableTv" */ './CableTv'),
        loading,
        chunkName: 'CableTv',
      })

export const CareTaker = Loadable({
        loader: () => import(/* webpackChunkName: "CareTaker" */ './CareTaker'),
        loading,
        chunkName: 'CareTaker',
      })

export const Concierge24 = Loadable({
        loader: () => import(/* webpackChunkName: "Concierge24" */ './Concierge24'),
        loading,
        chunkName: 'Concierge24',
      })

export const GarbagePickup = Loadable({
        loader: () => import(/* webpackChunkName: "GarbagePickup" */ './GarbagePickup'),
        loading,
        chunkName: 'GarbagePickup',
      })

export const GardenMaintenance = Loadable({
        loader: () => import(/* webpackChunkName: "GardenMaintenance" */ './GardenMaintenance'),
        loading,
        chunkName: 'GardenMaintenance',
      })

export const GardenRoom = Loadable({
        loader: () => import(/* webpackChunkName: "GardenRoom" */ './GardenRoom'),
        loading,
        chunkName: 'GardenRoom',
      })

export const Heating = Loadable({
        loader: () => import(/* webpackChunkName: "Heating" */ './Heating'),
        loading,
        chunkName: 'Heating',
      })

export const HotWater = Loadable({
        loader: () => import(/* webpackChunkName: "HotWater" */ './HotWater'),
        loading,
        chunkName: 'HotWater',
      })

export const Hydro = Loadable({
        loader: () => import(/* webpackChunkName: "Hydro" */ './Hydro'),
        loading,
        chunkName: 'Hydro',
      })

export const RecreationFacility = Loadable({
        loader: () => import(/* webpackChunkName: "RecreationFacility" */ './RecreationFacility'),
        loading,
        chunkName: 'RecreationFacility',
      })

export const SnowRemoval = Loadable({
        loader: () => import(/* webpackChunkName: "SnowRemoval" */ './SnowRemoval'),
        loading,
        chunkName: 'SnowRemoval',
      })

export const Taxes = Loadable({
        loader: () => import(/* webpackChunkName: "Taxes" */ './Taxes'),
        loading,
        chunkName: 'Taxes',
      })

export const Icon24hConcierge = Loadable({
        loader: () => import(/* webpackChunkName: "Icon24hConcierge" */ './Icon24hConcierge'),
        loading,
        chunkName: 'Icon24hConcierge',
      })

export const AirConditioner = Loadable({
        loader: () => import(/* webpackChunkName: "AirConditioner" */ './AirConditioner'),
        loading,
        chunkName: 'AirConditioner',
      })

export const Armchair = Loadable({
        loader: () => import(/* webpackChunkName: "Armchair" */ './Armchair'),
        loading,
        chunkName: 'Armchair',
      })

export const ArtStudio = Loadable({
        loader: () => import(/* webpackChunkName: "ArtStudio" */ './ArtStudio'),
        loading,
        chunkName: 'ArtStudio',
      })

export const Badminton = Loadable({
        loader: () => import(/* webpackChunkName: "Badminton" */ './Badminton'),
        loading,
        chunkName: 'Badminton',
      })

export const Basketball = Loadable({
        loader: () => import(/* webpackChunkName: "Basketball" */ './Basketball'),
        loading,
        chunkName: 'Basketball',
      })

export const Bbq = Loadable({
        loader: () => import(/* webpackChunkName: "Bbq" */ './Bbq'),
        loading,
        chunkName: 'Bbq',
      })

export const BeanfieldComing = Loadable({
        loader: () => import(/* webpackChunkName: "BeanfieldComing" */ './BeanfieldComing'),
        loading,
        chunkName: 'BeanfieldComing',
      })

export const Beanfield = Loadable({
        loader: () => import(/* webpackChunkName: "Beanfield" */ './Beanfield'),
        loading,
        chunkName: 'Beanfield',
      })

export const BicycleParking = Loadable({
        loader: () => import(/* webpackChunkName: "BicycleParking" */ './BicycleParking'),
        loading,
        chunkName: 'BicycleParking',
      })

export const BicycleSharing = Loadable({
        loader: () => import(/* webpackChunkName: "BicycleSharing" */ './BicycleSharing'),
        loading,
        chunkName: 'BicycleSharing',
      })

export const Bicycle = Loadable({
        loader: () => import(/* webpackChunkName: "Bicycle" */ './Bicycle'),
        loading,
        chunkName: 'Bicycle',
      })

export const Bowling = Loadable({
        loader: () => import(/* webpackChunkName: "Bowling" */ './Bowling'),
        loading,
        chunkName: 'Bowling',
      })

export const BuildingSafety = Loadable({
        loader: () => import(/* webpackChunkName: "BuildingSafety" */ './BuildingSafety'),
        loading,
        chunkName: 'BuildingSafety',
      })

export const BusinessCenter = Loadable({
        loader: () => import(/* webpackChunkName: "BusinessCenter" */ './BusinessCenter'),
        loading,
        chunkName: 'BusinessCenter',
      })

export const CarGarage = Loadable({
        loader: () => import(/* webpackChunkName: "CarGarage" */ './CarGarage'),
        loading,
        chunkName: 'CarGarage',
      })

export const CarParking = Loadable({
        loader: () => import(/* webpackChunkName: "CarParking" */ './CarParking'),
        loading,
        chunkName: 'CarParking',
      })

export const CarSharing = Loadable({
        loader: () => import(/* webpackChunkName: "CarSharing" */ './CarSharing'),
        loading,
        chunkName: 'CarSharing',
      })

export const CarWash = Loadable({
        loader: () => import(/* webpackChunkName: "CarWash" */ './CarWash'),
        loading,
        chunkName: 'CarWash',
      })

export const Car = Loadable({
        loader: () => import(/* webpackChunkName: "Car" */ './Car'),
        loading,
        chunkName: 'Car',
      })

export const Cinema = Loadable({
        loader: () => import(/* webpackChunkName: "Cinema" */ './Cinema'),
        loading,
        chunkName: 'Cinema',
      })

export const Cleaning = Loadable({
        loader: () => import(/* webpackChunkName: "Cleaning" */ './Cleaning'),
        loading,
        chunkName: 'Cleaning',
      })

export const Concierge = Loadable({
        loader: () => import(/* webpackChunkName: "Concierge" */ './Concierge'),
        loading,
        chunkName: 'Concierge',
      })

export const Cooling = Loadable({
        loader: () => import(/* webpackChunkName: "Cooling" */ './Cooling'),
        loading,
        chunkName: 'Cooling',
      })

export const Dining = Loadable({
        loader: () => import(/* webpackChunkName: "Dining" */ './Dining'),
        loading,
        chunkName: 'Dining',
      })

export const DogAllowed = Loadable({
        loader: () => import(/* webpackChunkName: "DogAllowed" */ './DogAllowed'),
        loading,
        chunkName: 'DogAllowed',
      })

export const DogCleaning = Loadable({
        loader: () => import(/* webpackChunkName: "DogCleaning" */ './DogCleaning'),
        loading,
        chunkName: 'DogCleaning',
      })

export const DogForbidden = Loadable({
        loader: () => import(/* webpackChunkName: "DogForbidden" */ './DogForbidden'),
        loading,
        chunkName: 'DogForbidden',
      })

export const DogSpa = Loadable({
        loader: () => import(/* webpackChunkName: "DogSpa" */ './DogSpa'),
        loading,
        chunkName: 'DogSpa',
      })

export const DryCleaningService = Loadable({
        loader: () => import(/* webpackChunkName: "DryCleaningService" */ './DryCleaningService'),
        loading,
        chunkName: 'DryCleaningService',
      })

export const ElectricCarCharging = Loadable({
        loader: () => import(/* webpackChunkName: "ElectricCarCharging" */ './ElectricCarCharging'),
        loading,
        chunkName: 'ElectricCarCharging',
      })

export const Elevator = Loadable({
        loader: () => import(/* webpackChunkName: "Elevator" */ './Elevator'),
        loading,
        chunkName: 'Elevator',
      })

export const EvParking = Loadable({
        loader: () => import(/* webpackChunkName: "EvParking" */ './EvParking'),
        loading,
        chunkName: 'EvParking',
      })

export const FirePit = Loadable({
        loader: () => import(/* webpackChunkName: "FirePit" */ './FirePit'),
        loading,
        chunkName: 'FirePit',
      })

export const GamesRoom = Loadable({
        loader: () => import(/* webpackChunkName: "GamesRoom" */ './GamesRoom'),
        loading,
        chunkName: 'GamesRoom',
      })

export const Games = Loadable({
        loader: () => import(/* webpackChunkName: "Games" */ './Games'),
        loading,
        chunkName: 'Games',
      })

export const Garden = Loadable({
        loader: () => import(/* webpackChunkName: "Garden" */ './Garden'),
        loading,
        chunkName: 'Garden',
      })

export const Gazebo = Loadable({
        loader: () => import(/* webpackChunkName: "Gazebo" */ './Gazebo'),
        loading,
        chunkName: 'Gazebo',
      })

export const GolfMini = Loadable({
        loader: () => import(/* webpackChunkName: "GolfMini" */ './GolfMini'),
        loading,
        chunkName: 'GolfMini',
      })

export const GolfSimulator = Loadable({
        loader: () => import(/* webpackChunkName: "GolfSimulator" */ './GolfSimulator'),
        loading,
        chunkName: 'GolfSimulator',
      })

export const GuestRoom = Loadable({
        loader: () => import(/* webpackChunkName: "GuestRoom" */ './GuestRoom'),
        loading,
        chunkName: 'GuestRoom',
      })

export const Gym = Loadable({
        loader: () => import(/* webpackChunkName: "Gym" */ './Gym'),
        loading,
        chunkName: 'Gym',
      })

export const IndoorPool = Loadable({
        loader: () => import(/* webpackChunkName: "IndoorPool" */ './IndoorPool'),
        loading,
        chunkName: 'IndoorPool',
      })

export const Intercom = Loadable({
        loader: () => import(/* webpackChunkName: "Intercom" */ './Intercom'),
        loading,
        chunkName: 'Intercom',
      })

export const InternetWifi = Loadable({
        loader: () => import(/* webpackChunkName: "InternetWifi" */ './InternetWifi'),
        loading,
        chunkName: 'InternetWifi',
      })

export const Internet = Loadable({
        loader: () => import(/* webpackChunkName: "Internet" */ './Internet'),
        loading,
        chunkName: 'Internet',
      })

export const Jacuzzi = Loadable({
        loader: () => import(/* webpackChunkName: "Jacuzzi" */ './Jacuzzi'),
        loading,
        chunkName: 'Jacuzzi',
      })

export const Library = Loadable({
        loader: () => import(/* webpackChunkName: "Library" */ './Library'),
        loading,
        chunkName: 'Library',
      })

export const Meeting = Loadable({
        loader: () => import(/* webpackChunkName: "Meeting" */ './Meeting'),
        loading,
        chunkName: 'Meeting',
      })

export const OutdoorGames = Loadable({
        loader: () => import(/* webpackChunkName: "OutdoorGames" */ './OutdoorGames'),
        loading,
        chunkName: 'OutdoorGames',
      })

export const OutdoorPool = Loadable({
        loader: () => import(/* webpackChunkName: "OutdoorPool" */ './OutdoorPool'),
        loading,
        chunkName: 'OutdoorPool',
      })

export const Outside = Loadable({
        loader: () => import(/* webpackChunkName: "Outside" */ './Outside'),
        loading,
        chunkName: 'Outside',
      })

export const ParcelStorage = Loadable({
        loader: () => import(/* webpackChunkName: "ParcelStorage" */ './ParcelStorage'),
        loading,
        chunkName: 'ParcelStorage',
      })

export const ParkingGarage = Loadable({
        loader: () => import(/* webpackChunkName: "ParkingGarage" */ './ParkingGarage'),
        loading,
        chunkName: 'ParkingGarage',
      })

export const Parking = Loadable({
        loader: () => import(/* webpackChunkName: "Parking" */ './Parking'),
        loading,
        chunkName: 'Parking',
      })

export const Party = Loadable({
        loader: () => import(/* webpackChunkName: "Party" */ './Party'),
        loading,
        chunkName: 'Party',
      })

export const Path = Loadable({
        loader: () => import(/* webpackChunkName: "Path" */ './Path'),
        loading,
        chunkName: 'Path',
      })

export const Piano = Loadable({
        loader: () => import(/* webpackChunkName: "Piano" */ './Piano'),
        loading,
        chunkName: 'Piano',
      })

export const PlayIndoors = Loadable({
        loader: () => import(/* webpackChunkName: "PlayIndoors" */ './PlayIndoors'),
        loading,
        chunkName: 'PlayIndoors',
      })

export const PlayOutdoors = Loadable({
        loader: () => import(/* webpackChunkName: "PlayOutdoors" */ './PlayOutdoors'),
        loading,
        chunkName: 'PlayOutdoors',
      })

export const Pool = Loadable({
        loader: () => import(/* webpackChunkName: "Pool" */ './Pool'),
        loading,
        chunkName: 'Pool',
      })

export const PublicTransport = Loadable({
        loader: () => import(/* webpackChunkName: "PublicTransport" */ './PublicTransport'),
        loading,
        chunkName: 'PublicTransport',
      })

export const RockClimbing = Loadable({
        loader: () => import(/* webpackChunkName: "RockClimbing" */ './RockClimbing'),
        loading,
        chunkName: 'RockClimbing',
      })

export const Rooftop = Loadable({
        loader: () => import(/* webpackChunkName: "Rooftop" */ './Rooftop'),
        loading,
        chunkName: 'Rooftop',
      })

export const RoomService = Loadable({
        loader: () => import(/* webpackChunkName: "RoomService" */ './RoomService'),
        loading,
        chunkName: 'RoomService',
      })

export const SafetyGuard = Loadable({
        loader: () => import(/* webpackChunkName: "SafetyGuard" */ './SafetyGuard'),
        loading,
        chunkName: 'SafetyGuard',
      })

export const Safety = Loadable({
        loader: () => import(/* webpackChunkName: "Safety" */ './Safety'),
        loading,
        chunkName: 'Safety',
      })

export const Satelite = Loadable({
        loader: () => import(/* webpackChunkName: "Satelite" */ './Satelite'),
        loading,
        chunkName: 'Satelite',
      })

export const Sauna = Loadable({
        loader: () => import(/* webpackChunkName: "Sauna" */ './Sauna'),
        loading,
        chunkName: 'Sauna',
      })

export const ShuttleBus = Loadable({
        loader: () => import(/* webpackChunkName: "ShuttleBus" */ './ShuttleBus'),
        loading,
        chunkName: 'ShuttleBus',
      })

export const Spa = Loadable({
        loader: () => import(/* webpackChunkName: "Spa" */ './Spa'),
        loading,
        chunkName: 'Spa',
      })

export const Squash = Loadable({
        loader: () => import(/* webpackChunkName: "Squash" */ './Squash'),
        loading,
        chunkName: 'Squash',
      })

export const Storage = Loadable({
        loader: () => import(/* webpackChunkName: "Storage" */ './Storage'),
        loading,
        chunkName: 'Storage',
      })

export const Sundeck = Loadable({
        loader: () => import(/* webpackChunkName: "Sundeck" */ './Sundeck'),
        loading,
        chunkName: 'Sundeck',
      })

export const TableTennis = Loadable({
        loader: () => import(/* webpackChunkName: "TableTennis" */ './TableTennis'),
        loading,
        chunkName: 'TableTennis',
      })

export const Tennis = Loadable({
        loader: () => import(/* webpackChunkName: "Tennis" */ './Tennis'),
        loading,
        chunkName: 'Tennis',
      })

export const Theatre = Loadable({
        loader: () => import(/* webpackChunkName: "Theatre" */ './Theatre'),
        loading,
        chunkName: 'Theatre',
      })

export const Tv = Loadable({
        loader: () => import(/* webpackChunkName: "Tv" */ './Tv'),
        loading,
        chunkName: 'Tv',
      })

export const Volleyball = Loadable({
        loader: () => import(/* webpackChunkName: "Volleyball" */ './Volleyball'),
        loading,
        chunkName: 'Volleyball',
      })

export const Warming = Loadable({
        loader: () => import(/* webpackChunkName: "Warming" */ './Warming'),
        loading,
        chunkName: 'Warming',
      })

export const Washing = Loadable({
        loader: () => import(/* webpackChunkName: "Washing" */ './Washing'),
        loading,
        chunkName: 'Washing',
      })

export const Water = Loadable({
        loader: () => import(/* webpackChunkName: "Water" */ './Water'),
        loading,
        chunkName: 'Water',
      })

export const WineCellar = Loadable({
        loader: () => import(/* webpackChunkName: "WineCellar" */ './WineCellar'),
        loading,
        chunkName: 'WineCellar',
      })

export const WineTasting = Loadable({
        loader: () => import(/* webpackChunkName: "WineTasting" */ './WineTasting'),
        loading,
        chunkName: 'WineTasting',
      })

export const Yoga = Loadable({
        loader: () => import(/* webpackChunkName: "Yoga" */ './Yoga'),
        loading,
        chunkName: 'Yoga',
      })

  export const svgComponents = {
    'building-insurance': BuildingInsurance,
  'building-maintenance': BuildingMaintenance,
  'building-management': BuildingManagement,
  'building-taxes': BuildingTaxes,
  'cable-tv': CableTv,
  'care-taker': CareTaker,
  'concierge-24': Concierge24,
  'garbage-pickup': GarbagePickup,
  'garden-maintenance': GardenMaintenance,
  'garden-room': GardenRoom,
  'heating': Heating,
  'hot-water': HotWater,
  'hydro': Hydro,
  'recreation-facility': RecreationFacility,
  'snow-removal': SnowRemoval,
  'taxes': Taxes,
  '24h-concierge': Icon24hConcierge,
  'air-conditioner': AirConditioner,
  'armchair': Armchair,
  'art-studio': ArtStudio,
  'badminton': Badminton,
  'basketball': Basketball,
  'bbq': Bbq,
  'beanfield-coming': BeanfieldComing,
  'beanfield': Beanfield,
  'bicycle-parking': BicycleParking,
  'bicycle-sharing': BicycleSharing,
  'bicycle': Bicycle,
  'bowling': Bowling,
  'building-safety': BuildingSafety,
  'business-center': BusinessCenter,
  'car-garage': CarGarage,
  'car-parking': CarParking,
  'car-sharing': CarSharing,
  'car-wash': CarWash,
  'car': Car,
  'cinema': Cinema,
  'cleaning': Cleaning,
  'concierge': Concierge,
  'cooling': Cooling,
  'dining': Dining,
  'dog-allowed': DogAllowed,
  'dog-cleaning': DogCleaning,
  'dog-forbidden': DogForbidden,
  'dog-spa': DogSpa,
  'dry-cleaning-service': DryCleaningService,
  'electric-car-charging': ElectricCarCharging,
  'elevator': Elevator,
  'ev-parking': EvParking,
  'fire-pit': FirePit,
  'games-room': GamesRoom,
  'games': Games,
  'garden': Garden,
  'gazebo': Gazebo,
  'golf-mini': GolfMini,
  'golf-simulator': GolfSimulator,
  'guest-room': GuestRoom,
  'gym': Gym,
  'indoor-pool': IndoorPool,
  'intercom': Intercom,
  'internet-wifi': InternetWifi,
  'internet': Internet,
  'jacuzzi': Jacuzzi,
  'library': Library,
  'meeting': Meeting,
  'outdoor-games': OutdoorGames,
  'outdoor-pool': OutdoorPool,
  'outside': Outside,
  'parcel-storage': ParcelStorage,
  'parking-garage': ParkingGarage,
  'parking': Parking,
  'party': Party,
  'path': Path,
  'piano': Piano,
  'play-indoors': PlayIndoors,
  'play-outdoors': PlayOutdoors,
  'pool': Pool,
  'public-transport': PublicTransport,
  'rock-climbing': RockClimbing,
  'rooftop': Rooftop,
  'room-service': RoomService,
  'safety-guard': SafetyGuard,
  'safety': Safety,
  'satelite': Satelite,
  'sauna': Sauna,
  'shuttle-bus': ShuttleBus,
  'spa': Spa,
  'squash': Squash,
  'storage': Storage,
  'sundeck': Sundeck,
  'table-tennis': TableTennis,
  'tennis': Tennis,
  'theatre': Theatre,
  'tv': Tv,
  'volleyball': Volleyball,
  'warming': Warming,
  'washing': Washing,
  'water': Water,
  'wine-cellar': WineCellar,
  'wine-tasting': WineTasting,
  'yoga': Yoga,
  }
  